export type TLinkButtonSize = 'small' | 'normal' | 'large';
export const LINKBUTTON_VARIANTS = ['primary', 'secondary', 'tertiary', 'light', 'link'] as const;
export type TLinkButtonVariant = typeof LINKBUTTON_VARIANTS[number];
export type TLinkButtonAlign = 'left' | 'center' | 'right';
export const LINK_ARIA_ATTRIBUTES = ['aria-label'] as const;
export type TLinkAriaAttribute = typeof LINK_ARIA_ATTRIBUTES[number];
